/**
 * UI permission-keys for the `WORKER` route (Workers screen).
 * Typed mirror of the BE CSV — confirm strings with the BE. (ENT-89 T15.)
 */
export const WorkerAclKeys = {
  /** Access to the /workforce (Workers) listing + detail subtree. */
  listingRead: 'workers:listing:read',
  /** Add Worker — gates BOTH the launcher button and the /onboarding/worker route. */
  onboard: 'workers:onboard',
} as const;

export type WorkerAclKey = (typeof WorkerAclKeys)[keyof typeof WorkerAclKeys];
